import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import "./TableSubSection.css";
import { PhoneOff, ArrowLeft } from "lucide-react";
import ApiService from "../../services/Api.service";

export default function TableSubSection({
  data,
  onOpenCloseDisposition,
  onBackDisposition,
  dispositionForm,
  isDispositionOpen = false,
  isCallEndButton = false,
}) {
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [headers, setHeaders] = useState({});

  const capitalize = (str) =>
    str
      .replace(/_/g, " ")
      .split(" ")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  useEffect(() => {
    if (!data) return;

    setLoading(true);

    ApiService.getLeadDetailsById(data.id)
      .then((res) => {
        const apiData = res.data;
        setDetails(apiData.data);

        if (apiData.header) setHeaders(apiData.header);

        setActiveTab(Object.keys(apiData.data).find((k) => k !== "headers") || "");
      })
      .catch((err) => console.error("Error fetching lead details:", err))
      .finally(() => setLoading(false));
  }, [data]);

  const renderContent = () => {
    if (!details || !activeTab) return null;

    const tabData = details[activeTab];

    // Array Case
    if (Array.isArray(tabData)) {
      if (tabData.length && typeof tabData[0] === "object") {
        return (
          <div className="sub-section-block">
            <table>
              <thead>
                <tr>
                  {headers.map((header, i) => (
                    <th key={i}>{header.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tabData.map((item, idx) => (
                  <tr key={idx}>
                    {headers.map((header) => (
                      <td key={header}>
                        {header === "recording_url" && item[header.value] ? (
                          <a href={item[header]} target="_blank" rel="noopener noreferrer">
                            Listen
                          </a>
                        ) : (
                          item[header.value]
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      }

      return (
        <div className="sub-section-block">
          <ul>
            {tabData.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      );
    }

    // Object Case — UL LIST with dynamic columns
    if (typeof tabData === "object") {
      return (
        <div className="sub-section-block">
          <ul className="info-list multi-column">
            {Object.entries(tabData).map(([key, value]) => (
              <li key={key}>
                <strong>{capitalize(key)}:</strong> {value}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return (
      <div className="sub-section-block">
        <p className="sub-section-text">{tabData}</p>
      </div>
    );
  };

  const tabs = details ? Object.keys(details).filter((k) => k !== "headers") : [];

  return (
    <>
      {loading && <Loader />}
      <div className="sub-section-container">
        <div className="tabs-container">
          <div className="tabs">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {capitalize(tab)}
              </div>
            ))}
          </div>
        </div>

        <div className="tab-content">{renderContent()}</div>
        {isDispositionOpen ? (
          <div style={{ marginTop: "10px" }}>
            <span
              title="Back"
              onClick={() => onBackDisposition?.()}
              style={{ display: "inline-flex", alignItems: "center", gap: "4px", cursor: "pointer" }}
            >
              <ArrowLeft size={18} />
              Back
            </span>
          </div>
        ) : null}
        {dispositionForm ? <div style={{ marginTop: "10px" }}>{dispositionForm}</div> : null}
        <div className="call-icons">

          {!isDispositionOpen &&isCallEndButton? (
            <div className="disconnected-icon">
            <PhoneOff
              title="Customer Feedback"
              onClick={() => onOpenCloseDisposition?.(data?.call_id || data?.id)}
            />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
